const ProductHero = () => {
  return (
    <section className="pt-32 pb-20 bg-gradient-to-b from-dark via-dark-lighter to-dark relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgxNiwgMTg1LCAxMjksIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="absolute top-20 right-1/4 w-96 h-96 bg-emerald/10 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-dark/20 border border-emerald/30 mb-8">
          <i className="ri-cpu-line text-emerald text-lg"></i>
          <span className="text-emerald text-sm font-medium whitespace-nowrap">Gelişmiş Teknoloji</span>
        </div>

        <h1 className="text-6xl lg:text-7xl font-black text-beige-light mb-8 leading-tight">
          Ürünler & Teknoloji
        </h1>

        <p className="text-2xl text-beige/70 leading-relaxed max-w-3xl mx-auto">
          BAGA'nın arka planında çalışan teknoloji ve karar üretim süreçleri hakkında detaylı bilgi edinin.
        </p>
      </div>
    </section>
  );
};

export default ProductHero;
